export const REORDER_ALLOW_LIST = ['chapters', 'page_groups', 'pages', 'elements'];
